module.exports = __webpack_public_path__ + "static/media/step4-poster.4889e45b.png";